import React from 'react';

class SecuritySettingsView extends React.Component {
  render() {
    return (
      <div>Settings/Security</div>
    )
  }
}

export default SecuritySettingsView



// WEBPACK FOOTER //
// ./src/views/settings/security.react.js